/* Blessed Choice — Calculadora de frete no PDP (v1.5.3: frete grátis por região via window.bcFreeShip — barra só com carrinho real; calculadora fala em projeção ("Levando esta peça…") enquanto a peça não está no carrinho; v1.4.3: recota sozinha quando o carrinho muda — bc:cart-changed do painel — e, com a peça já no carrinho, cota só o carrinho) — paridade Yampi
 * Cota CARRINHO ATUAL + este produto (o mesmo conjunto que a Yampi cotará no checkout).
 * Sem dependências. Lê a variante atual do formulário do tema Evolution
 * ([name="id"] — select ou input hidden — ou ?variant= na URL) e a quantidade
 * ([name="quantity"]), e envia peso/preço da variante ao Worker.
 */
(function () {
  'use strict';
  if (customElements.get('bc-frete')) return;

  var STORAGE_KEY = 'bc_frete_cep';
  var BRL = function (v) { return 'R$ ' + Number(v).toFixed(2).replace('.', ','); };
  /* P9 (23/10): frete grátis conta o valor DEPOIS do desconto do combo (igual ao checkout); itens com price em R$ */
  var afterCombo = function (list, sub) { var cb = window.bcCombo; if (!cb || !cb.calc) return sub; var st = cb.calc({ items: list.map(function (it) { return { product_id: it.product_id, price: Math.round(Number(it.price || 0) * 100), quantity: Number(it.quantity || 0) }; }), items_subtotal_price: Math.round(sub * 100) }); return st && st.discount ? st.after : sub; };
  var maskCep = function (v) { v = String(v || '').replace(/\D/g, '').slice(0, 8); return v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v; };
  var read = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
  var save = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };

  class BcFrete extends HTMLElement {
    connectedCallback() {
      this.endpoint = this.dataset.endpoint;
      this.showAll = this.dataset.showAll !== 'false';
      this.qtySelector = this.dataset.qtySelector || '[name="quantity"]';
      this.productId = this.dataset.productId || '';
      this.variants = [];
      try { this.variants = JSON.parse(this.querySelector('[data-bc-variants]').textContent); } catch (e) {}

      this.form = this.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      this.input = this.querySelector('[data-bc-cep]');
      this.btn = this.querySelector('[data-bc-calc]');
      this.out = this.querySelector('[data-bc-result]');
      this.lastKey = null;

      var self = this;
      this.input.addEventListener('input', function (e) { e.target.value = maskCep(e.target.value); });
      this.input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.quote(); } });
      this.btn.addEventListener('click', function (e) { e.preventDefault(); self.quote(); });

      // Variante (swatch/select) ou quantidade (+/-) mudou → recalcula se já houver CEP
      var timer;
      var recheck = function () {
        clearTimeout(timer);
        timer = setTimeout(function () { if (self.input.value.length === 9 && self.lastKey) self.quote(true); }, 300);
      };
      document.addEventListener('change', recheck);
      document.addEventListener('click', function (e) { if (self.form && self.form.contains(e.target) && !self.contains(e.target)) recheck(); });
      window.addEventListener('popstate', recheck);
      // Depois de "Adicionar ao carrinho", o carrinho mudou → recota com o novo conteúdo
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-action="add-to-cart"], .product-form__add-button')) {
          setTimeout(function () { self.lastKey = null; if (self.input.value.length === 9) self.quote(true); }, 2500);
        }
      });
      // v1.4: o painel pós-clique avisa sempre que o carrinho muda (peça adicionada pelo seletor ou pelas sugestões) → recota na hora
      var recart = function () { clearTimeout(timer); timer = setTimeout(function () { self.lastKey = null; if (self.input.value.length === 9) self.quote(true); }, 150); };
      document.addEventListener('bc:cart-changed', recart);
      document.addEventListener('bc:added', recart);

      var stored = read(STORAGE_KEY);
      if (stored && stored.length === 9) { this.input.value = stored; this.quote(true); }
    }

    currentVariant() {
      var id = null;
      if (this.form) {
        var el = this.form.querySelector('[name="id"]:checked') || this.form.querySelector('[name="id"]');
        if (el && el.value) id = el.value;
      }
      var urlId = new URL(location.href).searchParams.get('variant');
      if (urlId) id = urlId; // a URL é atualizada pelo tema a cada troca de variante
      var v = null;
      for (var i = 0; i < this.variants.length; i++) if (String(this.variants[i].id) === String(id)) v = this.variants[i];
      return v || this.variants[0] || null;
    }

    currentQty() {
      var el = (this.form && this.form.querySelector(this.qtySelector)) || document.querySelector(this.qtySelector);
      var n = el ? parseInt(el.value, 10) : 1;
      return n > 0 ? n : 1;
    }

    setState(html, cls) {
      this.out.className = 'bc-frete__result' + (cls ? ' bc-frete__result--' + cls : '');
      this.out.innerHTML = html;
      this.out.dataset.ok = cls === 'ok' ? '1' : '';
    }

    quote(silent) {
      var cep = this.input.value;
      if (cep.length !== 9) { if (!silent) { this.setState(this.msg('invalid'), 'error'); this.input.focus(); } return; }
      var cartOnly = this.dataset.cartOnly === '1'; // P14-A (23/10): no /cart cota só o carrinho, sem variante
      var v = cartOnly ? null : this.currentVariant();
      if (!v && !cartOnly) { this.setState(this.msg('nosku'), 'error'); return; }
      var qty = this.currentQty();
      var self = this;
      save(STORAGE_KEY, cep);
      this.btn.disabled = true;
      this.setState('<span class="bc-frete__spinner" aria-hidden="true"></span> ' + this.msg('loading'), 'loading');

      this.getCart().then(function (cart) {
        // carrinho atual + este produto (se já estiver no carrinho, soma a quantidade)
        var cartQty = cart.reduce(function (n, it) { return n + it.quantity; }, 0); // antes de somar este produto
        var items = cart.map(function (it) { return Object.assign({}, it); }), found = false; // cópia: não altera o carrinho lido
        // v1.4: se o botão já virou "Finalizar compra", esta peça JÁ está no carrinho → cota só o carrinho (o mesmo conjunto da Yampi)
        var panelOpen = !!document.querySelector('bc-posadd[data-open="1"]');
        var inCart = !cartOnly && cart.some(function (it) { return String(it.variant_id) === String(v.id); });
        var already = (panelOpen && inCart) || (!!document.querySelector('.product-form__add-button[data-bc-direct="1"]') && cart.some(function (it) { return String(it.product_id) === String(self.productId); })); // v1.4.2: com o painel aberto e a variante escolhida já no carrinho → cota só o carrinho (mesmo número do painel)
        if (already || cartOnly) { qty = 0; }
        else {
          for (var i = 0; i < items.length; i++) if (String(items[i].variant_id) === String(v.id)) { items[i].quantity += qty; found = true; }
          if (!found) items.push({ variant_id: v.id, product_id: self.productId, sku: v.sku || '', price: v.price, weight: v.weight, quantity: qty });
        }
        if (!items.length) { self.btn.disabled = false; return; }
        var key = cep + '|' + items.map(function (it) { return it.variant_id + 'x' + it.quantity; }).join(',');
        self.lastKey = key;

        var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, 12000);
        return fetch(self.endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ zipcode: cep, items: items }),
          signal: ctrl ? ctrl.signal : undefined
        }).then(function (r) { return r.json(); }).then(function (j) {
          if (self.lastKey !== key) return; // resposta antiga
          if (!j.ok) { self.setState(self.msg('error'), 'error'); return; }
          if (j.blocked) { self.setState(self.msg('blocked'), 'blocked'); document.dispatchEvent(new CustomEvent('bc:frete-quoted', { detail: { cep: cep, blocked: true, uf: j.uf } })); return; }
          if (!j.quotes || !j.quotes.length) { self.setState(self.msg('error'), 'error'); return; }
          // v1.5: frete grátis por região (regra única em window.bcFreeShip = a mesma da Yampi): pedido ≥ mínimo e UF elegível → mais barata vira Grátis
          var fs = window.bcFreeShip, subtotal = afterCombo(items, items.reduce(function (n, it) { return n + Number(it.price || 0) * Number(it.quantity || 0); }, 0));
          var st = fs ? fs.check(j.uf, subtotal) : { eligible: false, free: false, missing: 0 };
          var quotes = j.quotes.map(function (q) { return Object.assign({}, q); });
          // Lote P20/P21 (23/10): na Yampi o grátis vale só na "Entrega Econômica" (planilha, o Worker não cota); Loggi/Olist seguem com o preço real
          if (st.free) quotes.unshift({ name: 'Entrega Econômica', price: 0, free: true, days: fs.ecoDays ? fs.ecoDays(j.uf) : 8 });
          // v1.5.1: a barra do topo só fala do que está DE FATO no carrinho (a cotação inclui esta peça como projeção; carrinho vazio → barra genérica)
          var cartSubtotal = afterCombo(cart, cart.reduce(function (n, it) { return n + Number(it.price || 0) * Number(it.quantity || 0); }, 0));
          var stCart = cartSubtotal > 0 && fs ? fs.check(j.uf, cartSubtotal) : null;
          self.freeState = st; window.bcFreeShipState = stCart; document.dispatchEvent(new CustomEvent('bc:freeship', { detail: stCart }));
          if (stCart && stCart.free) st = Object.assign({}, st, { cartFree: true }); // v1.5.3: o carrinho sozinho já é grátis → 'aplicado', não 'levando esta peça'
          self.render(quotes, qty, cartQty, st);
          document.dispatchEvent(new CustomEvent('bc:frete-quoted', { detail: { cep: cep, cheapest: quotes[0].price } })); // v1.4.3: o painel pós-clique atualiza a linha de frete
          if (window.dataLayer) window.dataLayer.push({ event: 'bc_frete_calculado', cep: cep, uf: j.uf, variant_id: v ? v.id : null, quantity: qty, cart_quantity: cartQty, cheapest: j.quotes[0].price });
        }).finally(function () { clearTimeout(t); });
      }).catch(function () { self.setState(self.msg('error'), 'error'); })
        .finally(function () { self.btn.disabled = false; });
    }

    /** Itens do carrinho Shopify (/cart.js) no formato do Worker. Falha → carrinho vazio. */
    getCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .then(function (c) {
          return (c.items || []).map(function (it) {
            return { variant_id: it.variant_id, product_id: it.product_id, sku: it.sku || '', price: (it.final_price || it.price) / 100, weight: (it.grams || 0) / 1000, quantity: it.quantity };
          });
        }).catch(function () { return []; });
    }

    render(quotes, qty, cartQty, st) {
      var self = this;
      var cheapest = quotes[0];
      var fastest = quotes.slice().sort(function (a, b) { return a.days - b.days || a.price - b.price; })[0];
      var list = this.showAll ? quotes : quotes.filter(function (q) { return q === cheapest || q === fastest; });
      var rows = list.map(function (q) { // P44 (25/10, GESTOR): cada opção em 1 linha, sem soma de prazos: "<Transportadora> · R$ X · entrega em N dias úteis após a postagem"
        var price = q.price === 0 ? self.msg('free') : BRL(q.price);
        return '<li class="bc-frete__row' + (q === cheapest ? ' bc-frete__row--best' : '') + '"><span class="bc-frete__one"><b>' + self.esc(q.name) + '</b> · ' + price + ' · ' +
          self.msg('days').replace('{days}', q.days) + '</span></li>';
      }).join('');
      var note = qty === 0
        ? this.msg('noteOnlyCart').replace('{total}', cartQty).replace('peças', cartQty === 1 ? 'peça' : 'peças').replace('das 1 peça', 'da 1 peça')
        : cartQty > 0
        ? this.msg('noteCart').replace('{total}', qty + cartQty).replace('{cart}', cartQty).replace('{qty}', qty)
        : this.msg('note').replace('{qty}', qty);
      // v1.5: linha do frete grátis (só pra UF elegível): "Faltam R$ X pro frete grátis" ou "Frete grátis aplicado"
      var fsLine = '';
      if (st && st.eligible) {
        var fs = window.bcFreeShip, cfg = fs.cfg, proj = qty > 0 && !st.cartFree; // v1.5.2: qty > 0 = a cotação inclui esta peça que AINDA não está no carrinho → frase de projeção ("Levando esta peça…"), nunca "aplicado"
        var txt = st.free
          ? ((proj ? this.msg('freeDoneFirst') : '') || (proj ? 'Levando esta peça, seu frete sai grátis (pedido acima de R$ {min})' : (this.msg('freeDone') || 'Frete grátis aplicado · pedido acima de R$ {min}')))
          : ((proj ? this.msg('freeMissingFirst') : '') || (proj ? 'Levando esta peça, faltam {missing} pro frete grátis (acima de R$ {min})' : (this.msg('freeMissing') || 'Faltam {missing} pro frete grátis (acima de R$ {min})')));
        fsLine = '<p class="bc-frete__free' + (st.free ? ' bc-frete__free--on' : '') + '">' + this.esc(txt.replace('{missing}', fs.brl(st.missing)).replace('{min}', String(cfg.min).replace('.', ','))) + '</p>';
      }
      this.setState('<ul class="bc-frete__list">' + rows + '</ul>' + (note ? '<p class="bc-frete__note">' + note + '</p>' : '') + fsLine, 'ok');
    }

    msg(k) { return this.dataset['msg' + k.charAt(0).toUpperCase() + k.slice(1)] || ''; }
    postMin() { return Number(this.dataset.postMin) || 2; } // P26: postagem em dias úteis (Configurações do tema)
    postMax() { return Number(this.dataset.postMax) || 3; }
    esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  }
  customElements.define('bc-frete', BcFrete);
})();
